module.exports = __webpack_public_path__ + "media/images/icons/customer-management-3c125b9e64ee4d6079c69c05aee69d00.svg";